import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=22f3b14e&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=22f3b14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3b14e",
  null
  
)

export default component.exports